import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import {
  LOADER_STYLE,
  PLEASE_WAIT_LABEL,
} from "../../../utils/GlobalConstants";

export default function AlertDialog() {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        className="Loader-style"
        PaperProps={{
          style: LOADER_STYLE,
        }}
        testid="loader"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{PLEASE_WAIT_LABEL}</DialogTitle>
        <CircularProgress />
      </Dialog>
    </React.Fragment>
  );
}
